import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Link } from '@livechat/design-system-react-components';

import Config from 'Config';
import Utils from 'modules/Utils';

interface Props {
  to: string;
  tabIndex?: number;
  qs?: string;
  onClick?: () => void;
  dataTestId?: string;
  children: React.ReactNode;
}

export const CustomLink: FC<Props> = ({ to, tabIndex, qs, onClick, dataTestId, children }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();

    if (onClick && typeof onClick === 'function') {
      onClick();
    }

    if (to) {
      let query = `?${Utils.oauthQuery(Config)}`;

      if (qs) {
        query += `&${qs}`;
      }

      navigate(`${to}${query}`);
    }
  };

  return (
    <Link href={to} bold={false} onClick={handleClick} data-testid={dataTestId} tabIndex={tabIndex}>
      {children}
    </Link>
  );
};
